export const newImageCrop = (url: string | null, obj: any) =>
  obj
    ? {
        url: url ? url : "",
        height: obj["height"],
        width: obj["width"],
        x: obj["x"] ? obj["x"] : 0,
        y: obj["Y"] ? obj["y"] : 0
      }
    : null;
